/**
 * Updates the app store with the data in the payload.
 * @param context
 * @param payload Key/value pair where `key` is the property name as string and `value` is the data as an object
 */
export default (context:any, payload:any) => {
    const data = context.rootGetters['appState/formData'][payload.key];
    if (data) {
        for (const key in payload.value) {
            if (!data[key] || payload.value[key] !== data[key]) {
                context.commit('appState/UPDATE_DATA', {
                    key  : payload.key,
                    value: payload.value,
                }, { root: true });
            }
        }
    } else {
        context.commit('appState/UPDATE_DATA', {
            key  : payload.key,
            value: payload.value,
        }, { root: true });
    }
};